var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOwnTemplateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5V10C2 10.55 2.45 11 3 11H21C21.55 11 22 10.55 22 10V5C22 4.45 21.55 4 21 4H3C2.45 4 2 4.45 2 5ZM11 20H21C21.55 20 22 19.55 22 19V14C22 13.45 21.55 13 21 13H11C10.45 13 10 13.45 10 14V19C10 19.55 10.45 20 11 20ZM3 20H7C7.55 20 8 19.55 8 19V14C8 13.45 7.55 13 7 13H3C2.45 13 2 13.45 2 14V19C2 19.55 2.45 20 3 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnTemplateIcon);
export default __webpack_public_path__ + "static/media/OwnTemplateIcon.976c02eb043fac5b3e97ea26d4a16619.svg";
export { ForwardRef as ReactComponent };